<template>
    <div>
        <HomeHero :heroImg="heroImg" :title="title" :paragraph="desc" />
        <BrandsMatter />
        <PIPLife />
    </div>
</template>

<script>
import HomeHero from '@c/home/HomeHero.vue';
import BrandsMatter from '../home/BrandsMatter.vue';
import PIPLife from '../home/PIPLife.vue';
export default {
    name: 'HomeNew',
    components: {
        HomeHero,
        BrandsMatter,
        PIPLife
    },
    data() {
        return {
            title: "Protective gear that works as hard as you do",
            desc: "We provided the solutions needed to make sure you deliver on any job site with next level protection.",
            heroImg: "/images/home-hero.webp",

        };
    }
}
</script>
